export default "__VITE_ASSET__CN8Isb3m__"